export const SELECTED_FILTERS_ORDERS_CHANGED = 'SELECTED_FILTERS_ORDERS_CHANGED'
export const RESET_ALL_FILTERS = 'RESET_ALL_FILTERS'
